<script>
import mediapoolElement from './element.vue';
import mediapoolElementTile from './mediapoolElementTile.vue';
import MediapoolListHeaderRow from "./mediapoolListHeaderRow.vue";

const placeholderData = {
    id: 0,
    media_type: 'mediaplaceholder',
    informations: {
        width: 1,
        height: 1,
        duration: 1
    },
    parameters: {},
    thumbnail: '',
    inactive: 0,
    file_name: 'dummy_placeholder',
    file_extension: 'jpg',
    original_image: 'dummy_placeholder.jpg',
    display_name: Lang.langGet("Create New"),
    created_at: '',
    updated_at: '',
    tags: []
}

export default {
    components: {
        MediapoolListHeaderRow,
        mediapoolElement,
        mediapoolElementTile
    },
    props: [
        'files',
        'loading',
        'small',
        'classes',
        'forceMode',
        'viewPrivilege',
        'editPrivilege',
        'deletePrivilege',
        'elementClass',
        'dragDrop',
        'add'
    ],
    data() {
        return {
            mode: 'tiles',
            placeholderData: placeholderData
        }
    },
    computed: {
        translations() {
            return {
                added: Lang.langGet("Added"),
                modified: Lang.langGet("Modified"),
                name: Lang.langGet("Name"),
                size: Lang.langGet("Size"),
                tags: Lang.langChoice("Tag|Tags", 2),
                validity: Lang.langGet("Validity"),
            }
        },
        listClass() {
            return this.classes;
        },
        elements() {
            return this.files.filter(file => {
                return file.parameters['validity-status'] !== 'past';
            });
        }
    },
    mounted() {
        this.mode = this.forceMode || (localStorage.getItem('mediapool-mode-' + Laravel.activeProject) ?? 'tiles');

        EaseEventBus.listen('mediapoolMode', (mode) => {
            this.mode = mode;
        });

        EaseEventBus.listen('multiEditMedia', (data) => {
            const media = this.elements.filter((media) => {
                return data.ids.includes(media.id)
            });
            EaseEventBus.fire('editMedia', media);
        });
    }
}
</script>

<template>
    <div class="mediapool-frame"
         id="mediapool-list"
         :class="listClass">
        <div class="clear" style="overflow: visible">
            <div v-if="mode === 'list'" class="mediapool-file-list">
                <mediapool-list-header-row/>
            </div>
            <v-container fluid v-if="mode==='tiles'">
                <v-row dense class="mediapool-list">
                    <mediapoolElementTile
                        v-if="mode === 'tiles' && dragDrop && add"
                        :media="placeholderData"
                        :view-privilege="viewPrivilege"
                        :edit-privilege="editPrivilege"
                        :delete-privilege="deletePrivilege"
                        :small="true"
                        mode="tiles"
                        :drag-drop="dragDrop"
                        :element-class="elementClass">
                    </mediapoolElementTile>
                    <template v-for="(media,key) in elements">
                        <mediapoolElementTile
                            :media="media"
                            :view-privilege="viewPrivilege"
                            :edit-privilege="editPrivilege"
                            :delete-privilege="deletePrivilege"
                            :small="small"
                            :mode="mode"
                            :key="key"
                            :drag-drop="dragDrop"
                            :element-class="elementClass">
                        </mediapoolElementTile>
                    </template>
                </v-row>
            </v-container>
            <template v-else>
                <div class="mediapool-list">
                    <template v-for="(media,key) in elements">
                        <mediapoolElement
                            :media="media"
                            :view-privilege="viewPrivilege"
                            :edit-privilege="editPrivilege"
                            :delete-privilege="deletePrivilege"
                            :small="small"
                            :mode="mode"
                            :key="key"
                            :drag-drop="dragDrop"
                            :element-class="elementClass">
                        </mediapoolElement>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>
